import { render } from "./manage-account.vue?vue&type=template&id=7bfbf9a0"
import script from "./manage-account.vue?vue&type=script&lang=js"
export * from "./manage-account.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__